import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import DuplicateIcon from "../assets/Duplicate_Icon.svg";
import SpinningIcon from "../SpinningIcon";
import styles from "./ListRowActions.module.css";

/**
 * Right-aligned row action buttons for list items.
 */
export function ListRowActions({
  className,
  onDuplicate,
  onArchive,
  onEdit,
  isArchived = false,
  disabled = false,
  isEditLoading = false,
  isDuplicateLoading = false,
  isArchiveLoading = false,
}) {
  return (
    <div className={classNames(styles.container, className)}>
      <button
        type="button"
        className={classNames(styles.button, styles.duplicateButton)}
        aria-label="Duplicate"
        onClick={onDuplicate}
        disabled={disabled}
      >
        {isDuplicateLoading ? (
          <SpinningIcon size={16} />
        ) : (
          <img
            src={DuplicateIcon}
            alt=""
            aria-hidden="true"
            className={styles.icon}
          />
        )}
      </button>

      <button
        type="button"
        className={classNames(
          styles.button,
          styles.darkButton,
          styles.archiveButton,
          {
            [styles.unarchiveButton]: isArchived,
          },
        )}
        onClick={onArchive}
        disabled={disabled}
      >
        {isArchiveLoading ? (
          <SpinningIcon size={16} />
        ) : isArchived ? (
          "Unarchive"
        ) : (
          "Archive"
        )}
      </button>

      <button
        type="button"
        className={classNames(
          styles.button,
          styles.darkButton,
          styles.editButton,
        )}
        onClick={onEdit}
        disabled={disabled}
      >
        {isEditLoading ? <SpinningIcon size={16} /> : "Edit"}
      </button>
    </div>
  );
}

ListRowActions.propTypes = {
  className: PropTypes.string,
  onDuplicate: PropTypes.func,
  onArchive: PropTypes.func,
  onEdit: PropTypes.func,
  isArchived: PropTypes.bool,
  disabled: PropTypes.bool,
  isEditLoading: PropTypes.bool,
  isDuplicateLoading: PropTypes.bool,
  isArchiveLoading: PropTypes.bool,
};
